import http from "./httpService";

const getAllBanks = (data) => {
  return http.get("/api/banks", data);
};


export default { getAllBanks };
